export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/CitiesIcon.c19a3538.svg","height":19,"width":20};